var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item-title',{staticClass:"base-table__table-name text-h5"},[_c('div',[_c('v-breadcrumbs',{attrs:{"items":_vm.itensBreadcrumb}})],1)]),_c('div',{staticClass:"pt-4"},[_c('list-files',{on:{"updateBreadcrumb":_vm.updateBreadcrumb}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }